import moment from 'moment';
import { API } from './api';
import {
  API_RESOURCE_URLS,
  APPLICATION_NAME,
  DATE_FORMAT,
  LOG_LEVEL,
} from '../constants';
import config from '../config/config';
import axios from 'axios';

const { API_BASE_URL } = config;

export const getLastAsnGeneratedDateForPlantAndLine = async (plant, line) => {
  if (!plant || !line) return;
  const response = await API.get(API_RESOURCE_URLS.LAST_ASN_GENERATED_DATE, {
    params: {
      plant,
      line,
    },
  });
  const data = response.data;
  const lineData = data.filter(entry => entry.line === line)[0];
  if (!lineData || !lineData.lastDate) return null;
  return moment(lineData.lastDate, DATE_FORMAT.ISO);
};

export const getLastAgsnGeneratedDateForPlantAndLine = async (plant, line) => {
  if (!plant || !line) return;
  const response = await API.get(API_RESOURCE_URLS.lastAgSNGeneratedDate(plant, line));
  const data = response.data;

  if (!data || !data.date) return null;
  return moment(data.date, DATE_FORMAT.ISO);
};
let lastAsnGeneratedDate = null;
export const fetchAllLinedOutAsnsForPlantAndLine = async (plant, line) => {
  if (plant !== null && line !== null) {
    lastAsnGeneratedDate = await getLastAsnGeneratedDateForPlantAndLine(
      plant,
      line,
    );
  }
  if (!lastAsnGeneratedDate) return { data: [] };
  const dayAfterLastAsnGeneratedDate = lastAsnGeneratedDate.add(1, 'days');
  return API.get(API_RESOURCE_URLS.getLinedOutChassis(plant, line),
    {
      params: {
        before: dayAfterLastAsnGeneratedDate.format(DATE_FORMAT.ISO),
      },
    }
  );
};

export const fetchPlants = async () => {
  const response = await API.get(API_RESOURCE_URLS.PLANTS);
  return response;
};

export const fetchLinesForGivenPlantAndPurpose = async (plant, purpose) => {
  const response = await API.get(
    API_RESOURCE_URLS.PLANTS + '/' + plant + '/lines?purpose=' + purpose,
  );
  return response;
};

export const fetchLinesForGivenPlant = async plant => {
  const response = await API.get(
    API_RESOURCE_URLS.PLANTS + '/' + plant + '/lines',
  );
  return response;
};

export const getUserProfile = async () => {
  const response = await API.get(API_RESOURCE_URLS.USER_PROFILE);
  return response.data;
};

export const logError = async (error, user) => {
  const message = buildErrorMessage(error);
  console.error(message);
  log(message, LOG_LEVEL.ERROR, user);
};

export const log = (message, level, user) => {
  const logMessage = {
    message: message,
    level: level.name,
    timestamp: moment().toISOString(),
    application: APPLICATION_NAME,
    user,
  };
  sendLogToService(logMessage);
};

export const sendLogToService = async log =>
  axios.post(API_BASE_URL + '/' + API_RESOURCE_URLS.LOG_ERROR, log, {
    headers: {
      Authorization: `Bearer ${window.keycloak && window.keycloak.token}`,
    },
  });

export const buildErrorMessage = error => {
  let message;
  if (!error) {
    return message;
  }

  if (error.response) {
    message =
      'Request ' +
      error.response.config?.method.toUpperCase() +
      ' ' +
      error.response.config?.url +
      ', params:' +
      JSON.stringify(error.response.config?.params) +
      ' failed, status:' +
      error.response.status;
  } else {
    message = error.message;

    if (error.stack) {
      message += ' sourceFunction:' + error.stack.split('\n')[1];
    }
    if (error.config) {
      message += ' request: ' + error.config.method + ' ' + error.config.url;
    }
  }
  return message || JSON.stringify(error);
};

export const fetchSequenceForDatePlantAndLine = (dateString, plant, line) =>
  API.get(API_RESOURCE_URLS.VC_SEQUENCE, {
    params: {
      from: dateString,
      to: dateString,
      plant,
      line,
    },
  });

export const fetchAggregateSequenceForDatePlantAndLine = (date, plant, line) =>
  API.get(API_RESOURCE_URLS.aggregateSequence(date, plant, line));

export const fetchAggregateFromFreePool = (date, plant, line) =>
  API.get(API_RESOURCE_URLS.aggregateSequenceFreePool(date, plant, line));

export const fetchEmergencyProducedChildMaterial = (plant, shopType) =>
  API.get(API_RESOURCE_URLS.emergencyProducedChildMaterial(plant, shopType));

export const fetchSwappableAgsn = (plant, line, materialId) =>
  API.get(API_RESOURCE_URLS.getSwappableAggregates(plant, line, materialId));

export const getPantnagarBiwProducedChildMaterials = (plantId, shopType, date) =>
  API.get(API_RESOURCE_URLS.getPantnagarBiwProducedChildMaterials(plantId, shopType, date));

export const getMasterShiftPerPlant = (plantId) => {
  return API.get(API_RESOURCE_URLS.getMasterShiftPerPlant(plantId));
}

export const getEvrNumberPerPlant = (plantId, fromDate, toDate) => {
  return API.get(API_RESOURCE_URLS.getAllEvrData(plantId, fromDate, toDate));
}

export const getAsnOverviewReport = (plantId, lineId, toDate, fromDate) => {
  return API.get(API_RESOURCE_URLS.getAsnOverviewReport(plantId, lineId, toDate, fromDate))
}